import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Card, Form } from 'tabler-react';
import DatePicker from 'react-datepicker';
import ConditionSelect from '../components/ConditionsSelect';
import LocationSelect from '../components/LocationSelect';
import EndedSelect from '../components/EndedSelect';

const RadioOption = ({
  onChange, currentSort, sort, label,
}) => (
  <Form.Radio
    checked={currentSort === sort}
    label={label}
    name="sort"
    value={sort}
    onChange={onChange}
  />
);

RadioOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentSort: PropTypes.string.isRequired,
  sort: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const SortOptions = memo(({ handleSortChange, sort }) => (
  <Card
    isCollapsible
    title="Sort By"
  >
    <Card.Body>
      <Form.Group label="Sort">
        <RadioOption
          label="Relevance"
          sort="RELEVANCE"
          currentSort={sort}
          onChange={handleSortChange}
        />
        <RadioOption
          label="Date (Most Recent First)"
          sort="DATE_DESC"
          currentSort={sort}
          onChange={handleSortChange}
        />
        <RadioOption
          label="Date (Oldest First)"
          sort="DATE_ASC"
          currentSort={sort}
          onChange={handleSortChange}
        />
        <RadioOption
          label="Bid Price (Highest First)"
          sort="BID_AMOUNT_DESC"
          currentSort={sort}
          onChange={handleSortChange}
        />
        <RadioOption
          label="Bid Price (Lowest First)"
          sort="BID_AMOUNT_ASC"
          currentSort={sort}
          onChange={handleSortChange}
        />
      </Form.Group>
    </Card.Body>
  </Card>
));

SortOptions.propTypes = {
  handleSortChange: PropTypes.func.isRequired,
  sort: PropTypes.string.isRequired,
};

const RenderDateFilter = memo(({ onDateRangeChange, olderThan, newerThan }) => (
  <React.Fragment>
    <Form.Group label="Ends Before">
      <DatePicker
        selected={olderThan}
        className="form-control"
        onChange={date => onDateRangeChange({ date, type: 'olderThan' })}
      />
    </Form.Group>
    <Form.Group label="Ends After">
      <DatePicker
        selected={newerThan}
        className="form-control"
        onChange={date => onDateRangeChange({ date, type: 'newerThan' })}
      />
    </Form.Group>
  </React.Fragment>
));

RenderDateFilter.propTypes = {
  onDateRangeChange: PropTypes.func.isRequired,
  olderThan: PropTypes.string,
  newerThan: PropTypes.string,
};

const AdvancedFilters = memo(({
  handleDateRangeChange, olderThan, newerThan,
  handleSelectCondition, handleClearConditions, conditions,
  locations, handleSelectLocation, handleSetLocations,
  handleSortChange, sort,
  handleEndedChange, ended,
}) => (
  <React.Fragment>
    <SortOptions handleSortChange={handleSortChange} sort={sort} />
    <Card
      isCollapsible
      title="Ends At"
    >
      <Card.Body>
        <RenderDateFilter
          onDateRangeChange={handleDateRangeChange}
          olderThan={olderThan}
          newerThan={newerThan}
        />
      </Card.Body>
    </Card>
    <Card
      isCollapsible
      title="Active/Ended"
    >
      <Card.Body>
        <EndedSelect
          handleSelectEnded={handleEndedChange}
          onClear={() => handleEndedChange({ ended: null })}
          ended={ended}
        />
      </Card.Body>
    </Card>
    <Card
      isCollapsible
      title="Condition"
    >
      <Card.Body>
        <ConditionSelect
          handleSelectCondition={handleSelectCondition}
          onClear={handleClearConditions}
          conditions={conditions}
        />
      </Card.Body>
    </Card>
    <Card
      title="Location"
      isCollapsible
      body={<LocationSelect handleSelectLocation={handleSelectLocation} handleSetLocations={handleSetLocations} locations={locations} />}
      footer="* Location filtering will not return items from the old site"
    />
  </React.Fragment>
));

AdvancedFilters.propTypes = {
  handleDateRangeChange: PropTypes.func.isRequired,
  olderThan: PropTypes.string,
  newerThan: PropTypes.string,
  handleSelectLocation: PropTypes.func.isRequired,
  handleClearConditions: PropTypes.func.isRequired,
  conditions: PropTypes.arrayOf(PropTypes.string).isRequired,
  locations: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleSelectCondition: PropTypes.func.isRequired,
  handleSortChange: PropTypes.func.isRequired,
  sort: PropTypes.string.isRequired,
};


export default AdvancedFilters;



// WEBPACK FOOTER //
// ./src/archive/advancedFilters.js